(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7643],{

/***/ 26858:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[communityId]",
      function () {
        return __webpack_require__(48293);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ EventCardInteractionWrapper_EventCardInteractionWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./__generated__/graphql/legacy/graphql.ts
var graphql = __webpack_require__(32681);
// EXTERNAL MODULE: ./helpers/interactions/index.ts
var interactions = __webpack_require__(56427);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./toga/Card.tsx
var Card = __webpack_require__(23077);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/Events/components/EventCardInteractionWrapper/EventCardInteractionWrapper.module.scss
var EventCardInteractionWrapper_module = __webpack_require__(26284);
var EventCardInteractionWrapper_module_default = /*#__PURE__*/__webpack_require__.n(EventCardInteractionWrapper_module);
;// CONCATENATED MODULE: ./components/Events/components/EventCardInteractionWrapper/EventCardInteractionWrapper.tsx




















var cx = bind_default().bind((EventCardInteractionWrapper_module_default()));
var EventCardInteractionWrapper = function(param) {
    var children = param.children, eventStatus = param.eventStatus, eventId = param.eventId, dataQA = param.dataQA;
    var router = (0,next_router.useRouter)();
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, trackEvent = ref.trackEvent, currentUser = ref.currentUser;
    var eventCardRef = (0,react.useRef)(null);
    var isPastEvent = eventStatus === graphql/* EventStatusTypes.Expired */.taS.Expired;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_LG */.k4;
    var handleOpenEventPanel = function(e, id) {
        e.preventDefault();
        if (isMobile) {
            e.stopPropagation();
            (0,routerHelpers/* goToEvent */.s6)(router, id, community.id);
        } else {
            var _obj;
            trackEvent(trackingEvents/* default.OPEN_LIVE_EVENT_DETAILS_TAB */.ZP.OPEN_LIVE_EVENT_DETAILS_TAB, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.LIVE_EVENT_ID */.Ku.LIVE_EVENT_ID, (0,rawId/* rawId */.b)(id || "")), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.LIVE_EVENT_ID_ENCODED */.Ku.LIVE_EVENT_ID_ENCODED, id), _obj));
            pubsub_default().publish(eventNames/* eventNames.OPEN_EVENT_PANEL */.S.OPEN_EVENT_PANEL, {
                eventId: eventId,
                lastElementRef: eventCardRef
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: cx("card", {
            "is-past-event": isPastEvent && !(0,userHelpers/* isAdmin */.GJ)(currentUser)
        }),
        "data-qa": dataQA,
        ref: eventCardRef
    }, (0,interactions/* a11yOnClick */.Z)(function(e) {
        var isTargetWithinFooter = e.target.closest('[class*="'.concat(Card/* togaFooterBlockName */.u, '"]'));
        if (!isTargetWithinFooter) {
            handleOpenEventPanel(e, eventId);
        }
    })), {
        children: children
    }));
};
/* harmony default export */ var EventCardInteractionWrapper_EventCardInteractionWrapper = (EventCardInteractionWrapper);

;// CONCATENATED MODULE: ./components/Events/components/EventCardInteractionWrapper/index.ts



/***/ }),

/***/ 30899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UpcomingEvents_UpcomingEvents; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./schema/Event/queries.ts + 1 modules
var queries = __webpack_require__(20143);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/Events/components/EventCard/EventCard.tsx
var EventCard = __webpack_require__(24159);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./__generated__/graphql/legacy/graphql.ts
var graphql = __webpack_require__(32681);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/VisibilityCloak/VisibilityCloak.tsx
var VisibilityCloak = __webpack_require__(37510);
// EXTERNAL MODULE: ./components/Events/components/EventCardInteractionWrapper/index.ts + 1 modules
var EventCardInteractionWrapper = __webpack_require__(49439);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Row-ef6c768c.js
var Row_ef6c768c = __webpack_require__(93928);
// EXTERNAL MODULE: ./toga/index.ts + 4 modules
var toga = __webpack_require__(82633);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(6482);
// EXTERNAL MODULE: ./components/InfoCard/index.ts + 3 modules
var InfoCard = __webpack_require__(4069);
// EXTERNAL MODULE: ./components/AdminOnlyIndicator/index.tsx
var AdminOnlyIndicator = __webpack_require__(31785);
// EXTERNAL MODULE: ./components/LearnMoreLink/index.ts + 1 modules
var LearnMoreLink = __webpack_require__(50547);
// EXTERNAL MODULE: ./components/Events/components/EventAdoptionPanel/EventAdoptionPanel.module.scss
var EventAdoptionPanel_module = __webpack_require__(98880);
var EventAdoptionPanel_module_default = /*#__PURE__*/__webpack_require__.n(EventAdoptionPanel_module);
// EXTERNAL MODULE: ./components/Image/index.ts + 1 modules
var Image = __webpack_require__(82513);
// EXTERNAL MODULE: ./components/Events/components/MiniEventPreviewCard/MiniEventPreviewCard.module.scss
var MiniEventPreviewCard_module = __webpack_require__(76131);
var MiniEventPreviewCard_module_default = /*#__PURE__*/__webpack_require__.n(MiniEventPreviewCard_module);
;// CONCATENATED MODULE: ./components/Events/components/MiniEventPreviewCard/MiniEventPreviewCard.tsx







var cx = bind_default().bind((MiniEventPreviewCard_module_default()));
// If we get rid of the text in this preview, we can remove this entire component
var MiniEventPreviewCard = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("mini-event-preview-card"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: cx("mini-event-preview-card__image"),
                height: 590,
                src: constants/* EVENT_ADOPTION_IMAGE */.Q,
                width: 850
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("mini-event-preview-card__content"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: cx("mini-event-preview-card__content__date"),
                        children: t("example-event-date", "January 1, 2:00 PM GMT-7")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: cx("mini-event-preview-card__content__title"),
                        children: t("example-event-title", "Weekly Group Q&A")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MiniEventPreviewCard_MiniEventPreviewCard = (MiniEventPreviewCard);

;// CONCATENATED MODULE: ./components/Events/components/EventAdoptionPanel/EventAdoptionPanel.tsx
















var EventAdoptionPanel_cx = bind_default().bind((EventAdoptionPanel_module_default()));
var EventAdoptionPanel = function(param) {
    var goToCreateEventPage = param.goToCreateEventPage;
    var EVENT_ADOPTION_KEY = "hideEventAdoptionPanel";
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    var isSaved = (0,useLocalStorage/* default */.Z)(EVENT_ADOPTION_KEY).isSaved;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(isSaved), hideAdoptionPanel = ref[0], setHideAdoptionPanel = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: hideAdoptionPanel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: EventAdoptionPanel_cx("event-adoption__hint-container"),
            "data-qa": "event-adoption__hint-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: EventAdoptionPanel_cx("event-adoption__hint-text"),
                    children: t("components-events-eventsAdoptionPanel-events_adoption_hint", "Increase student engagement with live events.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LearnMoreLink/* default */.Z, {
                    href: constants/* EVENT_LEARN_MORE_LINK */.pj,
                    padLeft: true
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoCard/* default */.Z, {
            dataQA: "event-adoption__panel",
            localStorageKey: EVENT_ADOPTION_KEY,
            title: t("components-events-eventsAdoptionPanel-events_adoption_header", "Host live events in your Community"),
            isDismissable: true,
            onClose: function() {
                setHideAdoptionPanel(true);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_ef6c768c.R, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(toga/* Col */.JX, {
                            lgColumns: 8,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: EventAdoptionPanel_cx("mb-2"),
                                    children: t("components-events-eventsAdoptionPanel-events_adoption_subtext", "Create dynamic, live learning experiences that engage your students and keep them coming back - now with invite emails and RSVP functionality.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: EventAdoptionPanel_cx("mb-1"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            appearance: "default",
                                            "aria-label": t("Go to create event form"),
                                            className: EventAdoptionPanel_cx("event-adoption__button-create"),
                                            color: community.primaryColor,
                                            "data-qa": "event-adoption__button-create",
                                            onClick: goToCreateEventPage,
                                            children: t("common-CREATE_EVENT", "CREATE EVENT")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            appearance: "ghost",
                                            "aria-label": t("common-learn_more", "Learn more"),
                                            className: EventAdoptionPanel_cx("event-adoption__button-learn-more"),
                                            "data-qa": "event-adoption__button-learn-more",
                                            href: constants/* EVENT_LEARN_MORE_LINK */.pj,
                                            target: "_blank",
                                            children: t("common-LEARN_MORE", "LEARN MORE")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(toga/* Col */.JX, {
                            lgColumns: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                                hideMD: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniEventPreviewCard_MiniEventPreviewCard, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminOnlyIndicator/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var EventAdoptionPanel_EventAdoptionPanel = (EventAdoptionPanel);

;// CONCATENATED MODULE: ./components/Events/components/EventAdoptionPanel/index.ts


// EXTERNAL MODULE: ./components/Events/components/UpcomingEvents/UpcomingEvents.module.scss
var UpcomingEvents_module = __webpack_require__(69372);
var UpcomingEvents_module_default = /*#__PURE__*/__webpack_require__.n(UpcomingEvents_module);
;// CONCATENATED MODULE: ./components/Events/components/UpcomingEvents/UpcomingEvents.tsx























var UpcomingEvents_cx = bind_default().bind((UpcomingEvents_module_default()));
var UpcomingEvents = function(param) {
    var _shouldDisplayHeader = param.shouldDisplayHeader, shouldDisplayHeader = _shouldDisplayHeader === void 0 ? true : _shouldDisplayHeader, _numberOfEvents = param.numberOfEvents, numberOfEvents = _numberOfEvents === void 0 ? constants/* NUMBER_OF_EVENTS_ON_HOME */.rv : _numberOfEvents, setHideComponent = param.setHideComponent;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref2.community, currentUser = ref2.currentUser, trackEvent = ref2.trackEvent;
    var t = (0,es/* useTranslation */.$G)().t;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_PHONE */.SO;
    var _query = router.query, eventIdParam = _query.eventId;
    var ref3 = (0,useQuery/* useQuery */.a)(queries/* LIVE_EVENTS_LIST_QUERY */.lq, {
        variables: {
            eventSourceId: community.id,
            eventStatus: graphql/* EventStatusTypes.Upcoming */.taS.Upcoming,
            numberOfEvents: numberOfEvents
        },
        fetchPolicy: "cache-first",
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), loading = ref3.loading, data = ref3.data;
    var events = data === null || data === void 0 ? void 0 : (ref = data.site) === null || ref === void 0 ? void 0 : ref.liveEvents;
    var eventsEdges = events === null || events === void 0 ? void 0 : events.edges;
    if (eventIdParam) {
        eventsEdges = eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.filter(function(edge) {
            var ref;
            return (edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.id) !== eventIdParam;
        }).slice(0, constants/* NUMBER_OF_EVENTS_ON_HOME */.rv);
    }
    var goToCreateEventPage = function() {
        trackEvent(trackingEvents/* default.CLICK_CREATE_LIVE_EVENT */.ZP.CLICK_CREATE_LIVE_EVENT, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "UpcomingEvents"));
        (0,routerHelpers/* goToNewEvent */.op)(router, community.id);
    };
    var goToEventsPage = function() {
        trackEvent(trackingEvents/* default.CLICK_SEE_ALL_EVENTS */.ZP.CLICK_SEE_ALL_EVENTS);
        (0,routerHelpers/* goToEvents */.MW)(router, community.id);
    };
    (0,react.useEffect)(function() {
        if (setHideComponent) {
            setHideComponent((eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length) === 0 || false);
        }
    }, [
        eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length
    ]);
    var createEventButton = (0,userHelpers/* canCreateEvent */.gt)(currentUser) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
            appearance: "utility",
            "aria-label": t("shared-CREATE_EVENT", "CREATE EVENT"),
            className: UpcomingEvents_cx("create-event__button"),
            "data-qa": "create-event__icon-button",
            name: "plus",
            title: t("shared-CREATE_EVENT", "CREATE EVENT"),
            onClick: goToCreateEventPage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
            appearance: "knockout",
            className: UpcomingEvents_cx("create-event__button"),
            "data-qa": "create-event__button",
            onClick: goToCreateEventPage,
            children: [
                t("shared-CREATE_EVENT", "CREATE EVENT"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                    name: "plus"
                })
            ]
        })
    });
    var seeAllButton = (events === null || events === void 0 ? void 0 : (ref1 = events.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
        appearance: "secondary",
        "data-qa": "see-all__button",
        onClick: goToEventsPage,
        children: t("SEE ALL")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-loading": loading,
        "data-qa": "upcoming-events",
        children: !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                shouldDisplayHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: UpcomingEvents_cx("upcoming-events__header"),
                    "data-qa": "upcoming-events-header",
                    children: (!(eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length) && (0,userHelpers/* isAdmin */.GJ)(currentUser) || !!(eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                                className: UpcomingEvents_cx("upcoming-events__header-title"),
                                children: t("components-events-upcomingEvents-UPCOMING_EVENTS", "UPCOMING EVENTS")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: UpcomingEvents_cx("upcoming-events__header-buttons"),
                                children: [
                                    createEventButton,
                                    !isMobile && seeAllButton
                                ]
                            })
                        ]
                    })
                }),
                (eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                    admins: true,
                    moderators: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventAdoptionPanel_EventAdoptionPanel, {
                        goToCreateEventPage: goToCreateEventPage
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: UpcomingEvents_cx("upcoming-events__list"),
                    children: [
                        eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.map(function(edge) {
                            var node = edge === null || edge === void 0 ? void 0 : edge.node;
                            if (node) {
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCardInteractionWrapper/* default */.Z, {
                                    dataQA: "upcoming-events__list-card",
                                    eventId: node.id,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard/* default */.Z, {
                                        endTime: node.endTime,
                                        id: node.id,
                                        imageAltText: node.imageAltText,
                                        imageUrl: node.imageUrl,
                                        interestedUserCount: (ref = node.interestedUsers) === null || ref === void 0 ? void 0 : ref.totalCount,
                                        isInterested: node.isInterested || false,
                                        startTime: node.startTime,
                                        timezone: currentUser === null || currentUser === void 0 ? void 0 : (ref1 = currentUser.profile) === null || ref1 === void 0 ? void 0 : ref1.timezone,
                                        title: node.title
                                    })
                                }, node.id);
                            }
                            return null;
                        }),
                        isMobile && seeAllButton
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var UpcomingEvents_UpcomingEvents = (UpcomingEvents);

;// CONCATENATED MODULE: ./components/Events/components/UpcomingEvents/index.ts



/***/ }),

/***/ 50547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LearnMoreLink_LearnMoreLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./components/LearnMoreLink/LearnMoreLink.module.scss
var LearnMoreLink_module = __webpack_require__(29592);
var LearnMoreLink_module_default = /*#__PURE__*/__webpack_require__.n(LearnMoreLink_module);
;// CONCATENATED MODULE: ./components/LearnMoreLink/LearnMoreLink.tsx






var cx = bind_default().bind((LearnMoreLink_module_default()));
var LearnMoreLink = function(param) {
    var className = param.className, href = param.href, _iconName = param.iconName, iconName = _iconName === void 0 ? "new-window" : _iconName, _padLeft = param.padLeft, padLeft = _padLeft === void 0 ? false : _padLeft, text = param.text;
    var t = (0,es/* useTranslation */.$G)().t;
    var additionalClassName = padLeft ? "pad-left" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: cx(className || "", "learn-more__link", additionalClassName),
            href: href,
            target: "_blank",
            children: [
                text || t("common-learn_more", "Learn more"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                    name: iconName
                })
            ]
        })
    });
};
/* harmony default export */ var LearnMoreLink_LearnMoreLink = (LearnMoreLink);

;// CONCATENATED MODULE: ./components/LearnMoreLink/index.ts



/***/ }),

/***/ 72353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FeatureCloak_FeatureCloak; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/SiteFeaturesContext/index.ts + 2 modules
var SiteFeaturesContext = __webpack_require__(40670);
;// CONCATENATED MODULE: ./components/VisibilityHelpers/FeatureCloak/FeatureCloak.tsx





var FeatureCloak = function(param) {
    var admins = param.admins, flags = param.flags, communityEventNotifications = param.communityEventNotifications, communityEvents = param.communityEvents, children = param.children;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref.currentUser, featureFlags = ref.featureFlags;
    var siteFeatures = (0,SiteFeaturesContext/* useSiteFeaturesContext */.Er)().siteFeatures;
    if (flags) {
        var anyFlagsDisabled = flags.some(function(flag) {
            return !featureFlags[flag];
        });
        if (anyFlagsDisabled) return null; // Hide if any of the flags are disabled
    }
    if (typeof communityEventNotifications === "boolean") {
        var ref1;
        // Only show if communityEventNotifications.isEnabled matches the passed boolean
        if ((siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref1 = siteFeatures.communityEventNotifications) === null || ref1 === void 0 ? void 0 : ref1.isEnabled) !== communityEventNotifications) {
            return null;
        }
    }
    if (typeof communityEvents === "boolean") {
        var ref2;
        // Only show if communityEvents.isEnabled matches the passed boolean
        if ((siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref2 = siteFeatures.communityEvents) === null || ref2 === void 0 ? void 0 : ref2.isEnabled) !== communityEvents) {
            return null;
        }
    }
    if (typeof admins === "boolean") {
        if ((0,userHelpers/* isAdmin */.GJ)(currentUser) !== admins) {
            return null;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var FeatureCloak_FeatureCloak = (FeatureCloak);

;// CONCATENATED MODULE: ./components/VisibilityHelpers/FeatureCloak/index.ts



/***/ }),

/***/ 75392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useToggle(defaultActiveItem, callback) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultActiveItem), activeItem = ref[0], setActiveItem = ref[1];
    var handleToggle = function(item) {
        setActiveItem(item);
        callback === null || callback === void 0 ? void 0 : callback();
    };
    return {
        activeItem: activeItem,
        handleToggle: handleToggle
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 48293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _communityId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Surface-649a6d6c.js
var Surface_649a6d6c = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./schema/User/queries.ts
var queries = __webpack_require__(72175);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./koba/components/SkeletonPost/index.ts
var SkeletonPost = __webpack_require__(13925);
// EXTERNAL MODULE: ./components/CommunityUsers/components/CommunityUsersSkeleton.module.scss
var CommunityUsersSkeleton_module = __webpack_require__(79206);
var CommunityUsersSkeleton_module_default = /*#__PURE__*/__webpack_require__.n(CommunityUsersSkeleton_module);
;// CONCATENATED MODULE: ./components/CommunityUsers/components/CommunityUsersSkeleton.tsx





var cx = bind_default().bind((CommunityUsersSkeleton_module_default()));
var CommunityUsersSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cx("community-users-skeleton"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("community-users-skeleton__avatar")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("community-users-skeleton__avatar")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("community-users-skeleton__avatar")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("community-users-skeleton__avatar")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("community-users-skeleton__total"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        height: "20px",
                        width: "25px"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_CommunityUsersSkeleton = (CommunityUsersSkeleton);

// EXTERNAL MODULE: ./components/CommunityUsers/components/CommunityUsersAvatars.tsx
var CommunityUsersAvatars = __webpack_require__(83622);
;// CONCATENATED MODULE: ./components/CommunityUsers/CommunityUsers.tsx








var CommunityUsers = function() {
    var ref, ref1, ref2, ref3;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref4 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref4.community, currentUser = ref4.currentUser;
    var ref5 = (0,useQuery/* useQuery */.a)(queries/* USERS_QUERY */.Lc, {
        variables: {
            communityId: community.id,
            numberOfUsers: 4
        },
        notifyOnNetworkStatusChange: true
    }), data = ref5.data, loading = ref5.loading;
    var totalUsers = (data === null || data === void 0 ? void 0 : (ref = data.community) === null || ref === void 0 ? void 0 : (ref1 = ref.communityUsers) === null || ref1 === void 0 ? void 0 : ref1.totalCount) || 0;
    var communityUsersEdges = data === null || data === void 0 ? void 0 : (ref2 = data.community) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.communityUsers) === null || ref3 === void 0 ? void 0 : ref3.edges;
    var filteredUsers = [];
    filteredUsers = (communityUsersEdges === null || communityUsersEdges === void 0 ? void 0 : communityUsersEdges.map(function(edge) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return {
            id: (edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.id) || "",
            fullName: (edge === null || edge === void 0 ? void 0 : (ref2 = edge.node) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.fullName) || "",
            profile: {
                avatarUrl: (edge === null || edge === void 0 ? void 0 : (ref4 = edge.node) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.profile) === null || ref6 === void 0 ? void 0 : ref6.avatarUrl) || ""
            }
        };
    }).filter(function(user) {
        return user.id !== currentUser.id;
    })) || [];
    // Makes sure the first UserAvatar shown is the current user logged
    filteredUsers === null || filteredUsers === void 0 ? void 0 : filteredUsers.unshift({
        id: currentUser.id,
        fullName: currentUser.fullName,
        profile: {
            avatarUrl: currentUser.avatarUrl
        }
    });
    // if filteredUsers length is bigger than 4 it means that the currentUser
    // wasn't returned by the USERS_QUERY and we need to display it + 3 users
    if (filteredUsers.length > 4) filteredUsers = filteredUsers.slice(0, 4);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommunityUsersSkeleton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityUsersAvatars/* default */.Z, {
            tooltipTitle: t("components-communityUsers-total_member_count_title", "{{communityName}} has {{userCount}} members", {
                communityName: community.name,
                userCount: totalUsers
            }),
            totalUsers: totalUsers,
            users: filteredUsers
        })
    });
};
/* harmony default export */ var CommunityUsers_CommunityUsers = (CommunityUsers);

;// CONCATENATED MODULE: ./components/CommunityUsers/index.ts


// EXTERNAL MODULE: ./components/Image/index.ts + 1 modules
var Image = __webpack_require__(82513);
// EXTERNAL MODULE: ./components/Hero/Hero.module.scss
var Hero_module = __webpack_require__(63890);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./components/Hero/Hero.tsx







var Hero_cx = bind_default().bind((Hero_module_default()));
var Hero = function(param) {
    var src = param.src, alt = param.alt, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Surface_649a6d6c.S, {
        className: Hero_cx("hero__wrapper", "mb-4"),
        children: [
            src && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: alt || "",
                className: Hero_cx("border-top-radius"),
                height: 160,
                src: src,
                width: 640
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: Hero_cx("hero__body", "p-3"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: Hero_cx("hero__body-header"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: Hero_cx("hero__title", "h3"),
                                title: title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityUsers_CommunityUsers, {})
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: Hero_cx("hero__description", "mt-2"),
                        title: description,
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./components/Hero/index.ts


// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./schema/Section/queries.ts
var Section_queries = __webpack_require__(47653);
// EXTERNAL MODULE: ./components/SpaceDetails/index.ts + 2 modules
var SpaceDetails = __webpack_require__(19024);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/SpaceCardsList/SpaceCardsList.module.scss
var SpaceCardsList_module = __webpack_require__(65982);
var SpaceCardsList_module_default = /*#__PURE__*/__webpack_require__.n(SpaceCardsList_module);
;// CONCATENATED MODULE: ./components/SpaceCardsList/SpaceCardsList.tsx















var SpaceCardsList_cx = bind_default().bind((SpaceCardsList_module_default()));
var SpaceCardsList = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, currentUser = ref.currentUser, featureFlags = ref.featureFlags;
    var t = (0,es/* useTranslation */.$G)().t;
    var isCoursesToCommunitiesEnabled = featureFlags[constants_featureFlags/* features.COURSES_TO_COMMUNITIES */.R.COURSES_TO_COMMUNITIES];
    var ref1 = (0,useQuery/* useQuery */.a)(Section_queries/* SECTION_QUERY */.z, {
        variables: {
            communityId: community.id,
            isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
        },
        notifyOnNetworkStatusChange: true,
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), loading = ref1.loading, data = ref1.data;
    var spaces = [];
    if (data === null || data === void 0 ? void 0 : data.community) {
        spaces = data.community.communitySections.edges[0].node.communitySpaces.edges;
    }
    var handleClick = function(event, filter) {
        event.preventDefault();
        (0,routerHelpers/* goToSpaces */.ZY)(router, filter, community.id, true);
    };
    /**
   * ToDo: PPG-1655 (https://thinkific.atlassian.net/browse/PPG-1655)
   * remove once we can get exclusive space members from query
   */ var isExclusiveMember = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                    className: SpaceCardsList_cx("space-cards-list__title"),
                    children: t("ALL SPACES")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: SpaceCardsList_cx("space-cards-list__wrapper"),
                    children: spaces.map(// eslint-disable-next-line react/no-unused-prop-types
                    function(param) {
                        var space = param.node;
                        var ref;
                        var totalPosts = (space === null || space === void 0 ? void 0 : space.posts) && new Intl.NumberFormat(currentUser.locale || "en", {
                            notation: "compact"
                        }).format(space.posts.totalCount);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            "aria-label": t("Go to {{space}}", {
                                space: space.name
                            }),
                            className: SpaceCardsList_cx("space-cards-list__anchor"),
                            href: "/communities/".concat(community.id, "/spaces/").concat(space.id),
                            onClick: function(event) {
                                return handleClick(event, space.id);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceDetails/* SpaceDetailsCard */.a, {
                                className: SpaceCardsList_cx("space-cards-list__details"),
                                description: space === null || space === void 0 ? void 0 : space.description,
                                footerAccessory: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: SpaceCardsList_cx("space-cards-list__footer"),
                                    "data-qa": "space-card-total-posts__text",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                            name: "message"
                                        }),
                                        (space === null || space === void 0 ? void 0 : (ref = space.posts) === null || ref === void 0 ? void 0 : ref.totalCount) === 1 ? t("{{total}} post", {
                                            total: totalPosts
                                        }) : t("{{total}} posts", {
                                            total: totalPosts
                                        })
                                    ]
                                }),
                                icon: space === null || space === void 0 ? void 0 : space.iconName,
                                imageAltText: space === null || space === void 0 ? void 0 : space.imageAltText,
                                imageUrl: space === null || space === void 0 ? void 0 : space.imageUrl,
                                isExclusiveMember: isExclusiveMember,
                                name: space === null || space === void 0 ? void 0 : space.name
                            })
                        }, space.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SpaceCardsList_SpaceCardsList = (SpaceCardsList);

;// CONCATENATED MODULE: ./components/SpaceCardsList/index.ts


// EXTERNAL MODULE: ./components/Events/components/UpcomingEvents/index.ts + 4 modules
var UpcomingEvents = __webpack_require__(30899);
// EXTERNAL MODULE: ./components/CreatePostCallToAction/index.ts + 7 modules
var CreatePostCallToAction = __webpack_require__(6811);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/P-3714214d.js
var P_3714214d = __webpack_require__(61783);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/InfoCard/variations/CreatePostCard/CreatePostCard.tsx
var CreatePostCard = __webpack_require__(6724);
;// CONCATENATED MODULE: ./components/HomeFeed/components/ExplanationCard.tsx







var ExplanationCard = function(param) {
    var onClick = param.onClick, _isTrending = param.isTrending, isTrending = _isTrending === void 0 ? false : _isTrending;
    var t = (0,es/* useTranslation */.$G)().t;
    var currentUser = (0,CommunityContext/* useCommunityContext */.v1)().currentUser;
    var userIsAdmin = (0,userHelpers/* isAdmin */.GJ)(currentUser);
    var latestPostsEmptyStateTitle = userIsAdmin ? t("components-homeFeed-moderator_title", "Create your first post to welcome members to your Community") : t("components-homeFeed-student_title", "Jump in and say hello to your Community!");
    var latestPostsEmptyStateContent = userIsAdmin ? t("components-homeFeed-moderator_description", "Engage your students with icebreakers. Encourage them to introduce themselves, share their favourite online course, or post assignments for feedback from the community.") : t("components-homeFeed-student_description", "You're in the right place with the right people. Get to know your fellow community members and give them a virtual wave by introducing yourself.");
    if (isTrending) {
        latestPostsEmptyStateTitle = userIsAdmin ? t("components-homeFeed-trending_posts_moderator_title", "Trending posts") : t("components-homeFeed-trending_posts_student_title", "What\u2019s on your mind?");
        latestPostsEmptyStateContent = userIsAdmin ? t("components-homeFeed-trending_posts_moderator_description", "Posts with the most engagement will show up here, driving even more visibility and momentum.") : t("components-homeFeed-trending_posts_student_description", "Share your ideas, questions and insights with your community.");
    }
    var latestPostsEmptyStateImageSrc = userIsAdmin ? constants/* HOME_FEED_LATEST_POSTS_MODERATOR */.uX : constants/* HOME_FEED_LATEST_POSTS_STUDENT */.QM;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostCard/* default */.Z, {
        content: latestPostsEmptyStateContent,
        dataQA: "empty-state-latest-posts",
        imageSrc: latestPostsEmptyStateImageSrc,
        title: latestPostsEmptyStateTitle,
        onClick: onClick
    });
};
/* harmony default export */ var components_ExplanationCard = (ExplanationCard);

// EXTERNAL MODULE: ./components/PostList/index.tsx + 6 modules
var PostList = __webpack_require__(63828);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./hooks/useToggle.ts
var useToggle = __webpack_require__(75392);
// EXTERNAL MODULE: ./components/VisibilityCloak/VisibilityCloak.tsx
var VisibilityCloak = __webpack_require__(37510);
// EXTERNAL MODULE: ./components/HomePosts/HomePosts.module.scss
var HomePosts_module = __webpack_require__(11243);
var HomePosts_module_default = /*#__PURE__*/__webpack_require__.n(HomePosts_module);
;// CONCATENATED MODULE: ./components/HomePosts/HomePosts.tsx


















var HomePosts_cx = bind_default().bind((HomePosts_module_default()));
var // eslint-disable-next-line no-shadow
ToggleItems;
(function(ToggleItems) {
    ToggleItems["LATEST"] = "LATEST";
    ToggleItems["TRENDING"] = "TRENDING";
})(ToggleItems || (ToggleItems = {}));
var HomePosts = function(param) {
    var postListState = param.postListState, openModal = param.openModal;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, trackEvent = ref.trackEvent;
    var t = (0,es/* useTranslation */.$G)().t;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_LG */.k4;
    var ref1 = (0,useToggle/* default */.Z)(ToggleItems.LATEST), activeItem = ref1.activeItem, handleToggle = ref1.handleToggle;
    var isTrendingPosts = activeItem === ToggleItems.TRENDING;
    (0,react.useEffect)(function() {
        // If user resizes to a desktop size toggle selection to LATEST
        // so, when they resize back to a small screen size it shows latest posts as active
        if (!isMobile && isTrendingPosts) handleToggle(ToggleItems.LATEST);
    }, [
        isMobile
    ]);
    var setButtonProps = function(isActive) {
        if (isActive) {
            return {
                isActive: true,
                color: community.primaryColor,
                appearance: "default"
            };
        }
        return {
            isActive: false,
            appearance: "ghost"
        };
    };
    var handleClickOnPostCTA = function() {
        trackEvent(trackingEvents/* default.POST_MODAL_OPENED */.ZP.POST_MODAL_OPENED, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "HomePosts"));
        openModal();
    };
    var latestPostsEmptyState = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExplanationCard, {
            isTrending: isTrendingPosts,
            onClick: handleClickOnPostCTA
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                hide: isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(P_3714214d.P, {
                    className: HomePosts_cx("home-posts__title"),
                    children: t("LATEST POSTS")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                hide: !isMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: HomePosts_cx("home-posts__filters"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            appearance: "ghost",
                            className: HomePosts_cx("home-posts__filters-latest"),
                            dataQA: "latest__button",
                            onClick: function() {
                                return handleToggle(ToggleItems.LATEST);
                            }
                        }, setButtonProps(activeItem === ToggleItems.LATEST)), {
                            children: t("common-LATEST", "LATEST")
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            appearance: "ghost",
                            className: HomePosts_cx("home-posts__filters-trending"),
                            dataQA: "trending__button",
                            onClick: function() {
                                return handleToggle(ToggleItems.TRENDING);
                            }
                        }, setButtonProps(isTrendingPosts)), {
                            children: t("common-TRENDING", "TRENDING")
                        }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostList/* default */.Z, {
                customEmptyState: latestPostsEmptyState(),
                emptyMessage: t("components-homeFeed-post_list_empty_message", "Start a discussion by creating a new post in a Space."),
                emptyTitle: t("Looks like you'll be the first!"),
                isTrending: isTrendingPosts,
                sharedState: postListState,
                t: t,
                shouldShowTagOnPost: true
            })
        ]
    });
};
/* harmony default export */ var HomePosts_HomePosts = (HomePosts);

// EXTERNAL MODULE: ./components/CommunityChecklist/index.ts + 1 modules
var CommunityChecklist = __webpack_require__(6106);
// EXTERNAL MODULE: ./components/VisibilityHelpers/FeatureCloak/index.ts + 1 modules
var FeatureCloak = __webpack_require__(72353);
;// CONCATENATED MODULE: ./components/HomeFeed/HomeFeed.tsx














var HomeFeed = function(param) {
    var t = param.t, community = param.community, postListState = param.postListState;
    var featureFlags = (0,CommunityContext/* useCommunityContext */.v1)().featureFlags;
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isTabletOrSmaller = width < constants/* SCREEN_LG */.k4;
    var isCommunitiesAsAProductEnabled = featureFlags[constants_featureFlags/* features.COMMUNITIES_AS_A_PRODUCT */.R.COMMUNITIES_AS_A_PRODUCT];
    var shouldShowCommunitiesChecklist = !community.published && isTabletOrSmaller && isCommunitiesAsAProductEnabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Hero, {
                description: community.description,
                src: community.imageUrl,
                title: community.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePostCallToAction/* default */.Z, {
                ariaLabel: t("components-homeFeed-call_to_action_aria_label", "Click to create a post"),
                dataQA: "home-create-post__textfield",
                inputId: "home-create-post__textfield-id",
                isModalOpen: isModalOpen,
                placeholderText: t("components-homeFeed-write_a_post_placeholder_text", "What\u2019s on your mind?"),
                setIsModalOpen: setIsModalOpen
            }),
            shouldShowCommunitiesChecklist && /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                admins: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityChecklist/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCloak/* default */.Z, {
                communityEvents: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpcomingEvents/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePosts_HomePosts, {
                openModal: function() {
                    return setIsModalOpen(true);
                },
                postListState: postListState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceCardsList_SpaceCardsList, {})
        ]
    });
};
/* harmony default export */ var HomeFeed_HomeFeed = (HomeFeed);

;// CONCATENATED MODULE: ./components/HomeFeed/index.ts


// EXTERNAL MODULE: ./components/Layouts/MainLayout/index.ts + 8 modules
var MainLayout = __webpack_require__(96748);
// EXTERNAL MODULE: ./components/CommunityHeader/CommunityHeader.tsx
var CommunityHeader = __webpack_require__(11357);
;// CONCATENATED MODULE: ./pages/[communityId]/index.tsx







var IndexPage = function(param) {
    var postListState = param.postListState;
    var t = (0,es/* useTranslation */.$G)().t;
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityHeader/* default */.Z, {
                pageTitle: t("pages-home_title", "Home")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeFeed_HomeFeed, {
                community: community,
                postListState: postListState,
                t: t
            })
        ]
    });
};
IndexPage.propTypes = {};
IndexPage.getLayout = MainLayout/* getLayout */.G;
/* harmony default export */ var _communityId_ = (IndexPage);


/***/ }),

/***/ 79206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"community-users-skeleton":"CommunityUsersSkeleton_community-users-skeleton__xACe4","community-users-skeleton__avatar":"CommunityUsersSkeleton_community-users-skeleton__avatar__438b0","community-users-skeleton__total":"CommunityUsersSkeleton_community-users-skeleton__total__hfS7Q"};

/***/ }),

/***/ 98880:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EventAdoptionPanel_sr-only--mobile__oH0Rb","sr-only":"EventAdoptionPanel_sr-only__I1uU5","error-message":"EventAdoptionPanel_error-message__3RIeh","form-inline-edit":"EventAdoptionPanel_form-inline-edit__er0v7","form-group":"EventAdoptionPanel_form-group__fvmwe","form-row":"EventAdoptionPanel_form-row__dG0Lx","form-inline":"EventAdoptionPanel_form-inline__h4iYH","error":"EventAdoptionPanel_error__BDg8A","input-group-append":"EventAdoptionPanel_input-group-append__iwfHi","input-group-currency":"EventAdoptionPanel_input-group-currency__QV06c","form-control":"EventAdoptionPanel_form-control__OxCdr","custom-select":"EventAdoptionPanel_custom-select__2QVMq","is-invalid":"EventAdoptionPanel_is-invalid__0Y4lI","is-valid":"EventAdoptionPanel_is-valid__To7lX","input-group":"EventAdoptionPanel_input-group__32iq3","input-group-text":"EventAdoptionPanel_input-group-text__6j3Gf","input-group-prepend":"EventAdoptionPanel_input-group-prepend__0p4le","valid-feedback":"EventAdoptionPanel_valid-feedback__4VZM_","invalid-feedback":"EventAdoptionPanel_invalid-feedback__Y_qyS","form-text":"EventAdoptionPanel_form-text__JhOMa","label":"EventAdoptionPanel_label__oNNvi","custom-control":"EventAdoptionPanel_custom-control__nQCBO","custom-control-label":"EventAdoptionPanel_custom-control-label__uKcEx","custom-control-label--empty":"EventAdoptionPanel_custom-control-label--empty__UoWFI","custom-control-input":"EventAdoptionPanel_custom-control-input__rQ1bK","mx-3":"EventAdoptionPanel_mx-3__QA6ve","mb-1":"EventAdoptionPanel_mb-1__6s_Bp","mb-2":"EventAdoptionPanel_mb-2__3IAiK","mb-3":"EventAdoptionPanel_mb-3__3SiNe","mb-4":"EventAdoptionPanel_mb-4__Ort5l","mb-5":"EventAdoptionPanel_mb-5__Fczwa","mt-2":"EventAdoptionPanel_mt-2__cTLG3","ml-1":"EventAdoptionPanel_ml-1__x_Wd9","p-2":"EventAdoptionPanel_p-2__setBE","p-3":"EventAdoptionPanel_p-3__CbY8g","border-box":"EventAdoptionPanel_border-box__FoQsq","d-inline-block":"EventAdoptionPanel_d-inline-block__5Zpvb","event-adoption__hint-container":"EventAdoptionPanel_event-adoption__hint-container__a9Eo1","event-adoption__hint-text":"EventAdoptionPanel_event-adoption__hint-text__lomNF","event-adoption__button":"EventAdoptionPanel_event-adoption__button__OI4L1","event-adoption__button-learn-more":"EventAdoptionPanel_event-adoption__button-learn-more__UR2ro","event-adoption__button-close":"EventAdoptionPanel_event-adoption__button-close__XCgbD"};

/***/ }),

/***/ 26284:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCardInteractionWrapper_card__rmYmS","is-past-event":"EventCardInteractionWrapper_is-past-event__cJoA1"};

/***/ }),

/***/ 76131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MiniEventPreviewCard_sr-only--mobile__R1Dza","sr-only":"MiniEventPreviewCard_sr-only__daSEV","error-message":"MiniEventPreviewCard_error-message__CHeCf","form-inline-edit":"MiniEventPreviewCard_form-inline-edit__WFrtj","form-group":"MiniEventPreviewCard_form-group__6mdu1","form-row":"MiniEventPreviewCard_form-row__E_lB4","form-inline":"MiniEventPreviewCard_form-inline__kHaHT","error":"MiniEventPreviewCard_error__O6B18","input-group-append":"MiniEventPreviewCard_input-group-append__nydAp","input-group-currency":"MiniEventPreviewCard_input-group-currency__EwW6X","form-control":"MiniEventPreviewCard_form-control__uISRX","custom-select":"MiniEventPreviewCard_custom-select__7_hKC","is-invalid":"MiniEventPreviewCard_is-invalid__LwYes","is-valid":"MiniEventPreviewCard_is-valid__0U2XK","input-group":"MiniEventPreviewCard_input-group__gt7iV","input-group-text":"MiniEventPreviewCard_input-group-text__hn_Ma","input-group-prepend":"MiniEventPreviewCard_input-group-prepend__BxZgZ","valid-feedback":"MiniEventPreviewCard_valid-feedback__KIeiO","invalid-feedback":"MiniEventPreviewCard_invalid-feedback__E8bku","form-text":"MiniEventPreviewCard_form-text__zn0Xj","label":"MiniEventPreviewCard_label__LdZeb","custom-control":"MiniEventPreviewCard_custom-control___16tS","custom-control-label":"MiniEventPreviewCard_custom-control-label__ecRok","custom-control-label--empty":"MiniEventPreviewCard_custom-control-label--empty__0wRep","custom-control-input":"MiniEventPreviewCard_custom-control-input__npFmO","mini-event-preview-card__image":"MiniEventPreviewCard_mini-event-preview-card__image__PR_LB","mini-event-preview-card__content":"MiniEventPreviewCard_mini-event-preview-card__content__6CeAX","mini-event-preview-card__content__date":"MiniEventPreviewCard_mini-event-preview-card__content__date__Hvb5X"};

/***/ }),

/***/ 69372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"UpcomingEvents_sr-only--mobile__kDFT0","sr-only":"UpcomingEvents_sr-only__e4U0r","error-message":"UpcomingEvents_error-message__VS_Nt","form-inline-edit":"UpcomingEvents_form-inline-edit__TCH7z","form-group":"UpcomingEvents_form-group__nylOQ","form-row":"UpcomingEvents_form-row__ibh4t","form-inline":"UpcomingEvents_form-inline__8muaF","error":"UpcomingEvents_error__MSR5i","input-group-append":"UpcomingEvents_input-group-append__K1T0h","input-group-currency":"UpcomingEvents_input-group-currency__rcwaZ","form-control":"UpcomingEvents_form-control__ii1_U","custom-select":"UpcomingEvents_custom-select__RyDB_","is-invalid":"UpcomingEvents_is-invalid__ywIOk","is-valid":"UpcomingEvents_is-valid__uVPKf","input-group":"UpcomingEvents_input-group__mrxmg","input-group-text":"UpcomingEvents_input-group-text__tscq6","input-group-prepend":"UpcomingEvents_input-group-prepend__j__rt","valid-feedback":"UpcomingEvents_valid-feedback__YvmS7","invalid-feedback":"UpcomingEvents_invalid-feedback__gC3EF","form-text":"UpcomingEvents_form-text__3BgNL","label":"UpcomingEvents_label__My0PG","custom-control":"UpcomingEvents_custom-control__QjVWg","custom-control-label":"UpcomingEvents_custom-control-label__DHZ55","custom-control-label--empty":"UpcomingEvents_custom-control-label--empty__IS_vY","custom-control-input":"UpcomingEvents_custom-control-input__Vm4kL","upcoming-events__list":"UpcomingEvents_upcoming-events__list__uqwwt","upcoming-events__list-card":"UpcomingEvents_upcoming-events__list-card__YkKop","upcoming-events__header":"UpcomingEvents_upcoming-events__header__gk4iq","upcoming-events__header-title":"UpcomingEvents_upcoming-events__header-title__e8LD5","upcoming-events__header-buttons":"UpcomingEvents_upcoming-events__header-buttons__IwtrZ","create-event__button":"UpcomingEvents_create-event__button__2zorI"};

/***/ }),

/***/ 63890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Hero_sr-only--mobile__cdh68","sr-only":"Hero_sr-only__eaWo9","error-message":"Hero_error-message__0_kcs","form-inline-edit":"Hero_form-inline-edit__ufLKv","form-group":"Hero_form-group__g4Um_","form-row":"Hero_form-row___7eNE","form-inline":"Hero_form-inline__Jvrz8","error":"Hero_error__vAtcy","input-group-append":"Hero_input-group-append__5CPKY","input-group-currency":"Hero_input-group-currency__6Waws","form-control":"Hero_form-control__Wj3F9","custom-select":"Hero_custom-select__vptjP","is-invalid":"Hero_is-invalid__ZEAsN","is-valid":"Hero_is-valid__Ux7MJ","input-group":"Hero_input-group__E10hg","input-group-text":"Hero_input-group-text___MFG0","input-group-prepend":"Hero_input-group-prepend__20X5j","valid-feedback":"Hero_valid-feedback__gg8Z7","invalid-feedback":"Hero_invalid-feedback__4IT_4","form-text":"Hero_form-text__8Lveh","label":"Hero_label__OPt1g","custom-control":"Hero_custom-control__xPXlC","custom-control-label":"Hero_custom-control-label__eHmFM","custom-control-label--empty":"Hero_custom-control-label--empty__KMtx_","custom-control-input":"Hero_custom-control-input__W0Ak_","h1":"Hero_h1__T4IIE","h2":"Hero_h2__843ro","h3":"Hero_h3__9S0xo","h4":"Hero_h4__Z5GvG","p":"Hero_p__HYN8s","caption":"Hero_caption__RJad9","mx-3":"Hero_mx-3__U95on","mb-1":"Hero_mb-1__aDwHT","mb-2":"Hero_mb-2__j9Plm","mb-3":"Hero_mb-3__VveSj","mb-4":"Hero_mb-4__D83_g","mb-5":"Hero_mb-5__UdUYP","mt-2":"Hero_mt-2__4FPiP","ml-1":"Hero_ml-1__qHopZ","p-2":"Hero_p-2__ufW4x","p-3":"Hero_p-3__gHJVs","border-box":"Hero_border-box___X6Ef","d-inline-block":"Hero_d-inline-block__3qFrN","border-top-radius":"Hero_border-top-radius__Xu___","hero__body-header":"Hero_hero__body-header__Xbjkx","hero__title":"Hero_hero__title__VT0DV","hero__description":"Hero_hero__description__Gr_Fz"};

/***/ }),

/***/ 11243:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"HomePosts_sr-only--mobile__ik7eI","sr-only":"HomePosts_sr-only__QVBQm","error-message":"HomePosts_error-message__fEABB","form-inline-edit":"HomePosts_form-inline-edit__zHsOg","form-group":"HomePosts_form-group__TfmA8","form-row":"HomePosts_form-row__YsdDE","form-inline":"HomePosts_form-inline__AnJwj","error":"HomePosts_error__xJRD_","input-group-append":"HomePosts_input-group-append__uYlOV","input-group-currency":"HomePosts_input-group-currency__YLUv_","form-control":"HomePosts_form-control__dVznu","custom-select":"HomePosts_custom-select__cORX9","is-invalid":"HomePosts_is-invalid__Pj6I5","is-valid":"HomePosts_is-valid__YJK9W","input-group":"HomePosts_input-group__gUjy6","input-group-text":"HomePosts_input-group-text__ftiHF","input-group-prepend":"HomePosts_input-group-prepend__pLo4u","valid-feedback":"HomePosts_valid-feedback__3ULnf","invalid-feedback":"HomePosts_invalid-feedback__Cr0X4","form-text":"HomePosts_form-text__4Roi5","label":"HomePosts_label__talKf","custom-control":"HomePosts_custom-control__n6wEr","custom-control-label":"HomePosts_custom-control-label__P_FaW","custom-control-label--empty":"HomePosts_custom-control-label--empty__QKi_U","custom-control-input":"HomePosts_custom-control-input__NL2vN","home-posts__title":"HomePosts_home-posts__title___PJ4E","home-posts__filters":"HomePosts_home-posts__filters__4ljnR","home-posts__filters-latest":"HomePosts_home-posts__filters-latest__A8cIv","home-posts__filters-trending":"HomePosts_home-posts__filters-trending__thJk3"};

/***/ }),

/***/ 29592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"learn-more__link":"LearnMoreLink_learn-more__link__9VQHn","pad-left":"LearnMoreLink_pad-left__SmIf3"};

/***/ }),

/***/ 65982:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"SpaceCardsList_sr-only--mobile__pMPjo","sr-only":"SpaceCardsList_sr-only__SBEdX","error-message":"SpaceCardsList_error-message__DhYq9","form-inline-edit":"SpaceCardsList_form-inline-edit__u8KkQ","form-group":"SpaceCardsList_form-group__dKpx1","form-row":"SpaceCardsList_form-row__QmM7e","form-inline":"SpaceCardsList_form-inline__tZ1wG","error":"SpaceCardsList_error__IF_Fq","input-group-append":"SpaceCardsList_input-group-append__4UmUh","input-group-currency":"SpaceCardsList_input-group-currency__pf7SA","form-control":"SpaceCardsList_form-control__ccboF","custom-select":"SpaceCardsList_custom-select__Kg_lX","is-invalid":"SpaceCardsList_is-invalid__ANdfE","is-valid":"SpaceCardsList_is-valid__t369q","input-group":"SpaceCardsList_input-group__61cY8","input-group-text":"SpaceCardsList_input-group-text__Cve0h","input-group-prepend":"SpaceCardsList_input-group-prepend__CYQkN","valid-feedback":"SpaceCardsList_valid-feedback__L0GxS","invalid-feedback":"SpaceCardsList_invalid-feedback__w1rdi","form-text":"SpaceCardsList_form-text__orb_1","label":"SpaceCardsList_label__VIKV4","custom-control":"SpaceCardsList_custom-control__DIDGT","custom-control-label":"SpaceCardsList_custom-control-label__Jboav","custom-control-label--empty":"SpaceCardsList_custom-control-label--empty__AcJa0","custom-control-input":"SpaceCardsList_custom-control-input__ORygW","space-cards-list__title":"SpaceCardsList_space-cards-list__title___yrQI","space-cards-list__wrapper":"SpaceCardsList_space-cards-list__wrapper__btdOk","space-cards-list__details":"SpaceCardsList_space-cards-list__details__7HSdc","space-cards-list__anchor":"SpaceCardsList_space-cards-list__anchor__JVQMb","space-cards-list__footer":"SpaceCardsList_space-cards-list__footer__bz10z"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [375,7229,3662,2234,76,923,5290,7859,3760,3253,7763,1178,8764,8568,4739,3993,6748,3852,3534,8175,9033,1475,1881,7477,9774,2888,179], function() { return __webpack_exec__(26858); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);